module.exports = __webpack_public_path__ + "static/media/no_message_dark.5d7f5205.svg";